import { render, staticRenderFns } from "./BarChartConfigModal.vue?vue&type=template&id=4ebf8a00&scoped=true&"
import script from "./BarChartConfigModal.vue?vue&type=script&lang=js&"
export * from "./BarChartConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./BarChartConfigModal.vue?vue&type=style&index=0&id=4ebf8a00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebf8a00",
  null
  
)

export default component.exports